// extracted by mini-css-extract-plugin
module.exports = {"widget":"widget_widget__3CCgj","heading":"widget_heading__1FXyq","content":"widget_content__25khL","loading":"widget_loading__3tlxF"};